var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_16065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6624 1.8418C6.0541 1.8418 2.3291 5.5668 2.3291 10.1751C2.3291 14.7835 6.0541 18.5085 10.6624 18.5085C15.2708 18.5085 18.9958 14.7835 18.9958 10.1751C18.9958 5.5668 15.2708 1.8418 10.6624 1.8418ZM14.2458 13.7585C13.9208 14.0835 13.3958 14.0835 13.0708 13.7585L10.6624 11.3501L8.2541 13.7585C7.9291 14.0835 7.4041 14.0835 7.0791 13.7585C6.7541 13.4335 6.7541 12.9085 7.0791 12.5835L9.48743 10.1751L7.0791 7.7668C6.7541 7.4418 6.7541 6.9168 7.0791 6.5918C7.4041 6.2668 7.9291 6.2668 8.2541 6.5918L10.6624 9.00013L13.0708 6.5918C13.3958 6.2668 13.9208 6.2668 14.2458 6.5918C14.5708 6.9168 14.5708 7.4418 14.2458 7.7668L11.8374 10.1751L14.2458 12.5835C14.5624 12.9001 14.5624 13.4335 14.2458 13.7585Z",
    fill: "#EE5D50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_16065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.662109 0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReject);
export default __webpack_public_path__ + "static/media/ic_reject.a667da1d9d368cc5e8707eb15cf7d6fa.svg";
export { ForwardRef as ReactComponent };